import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const Bar = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  background: rgba(255,255,255,0.88);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(0,0,0,0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  z-index: 90;
  box-shadow: 0 1px 8px rgba(0,0,0,0.04);
`;

const Logo = styled.div`
  font-size: 0.85rem;
  font-weight: 700;
  color: #334155;
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
  gap: 0.35rem;
`;

const routeTitles = {
  '/dashboard':   '',
  '/pedidos':     'Agenda',
  '/financeiro':  'Financeiro',
  '/editor/servicos': 'Serviços',
  '/configuracoes': 'Configurações',
};

const TopBar = () => {
  const location = useLocation();
  const title = routeTitles[location.pathname];
  const isDashboard = !title;

  return (
    <Bar>
      <Logo>
        ✂️ {isDashboard ? 'Magzy' : title}
      </Logo>
    </Bar>
  );
};

export default TopBar;
